<template>
  <customize-header class="page-address-list">
    <template #header>
      <top-bar show-header
               title="收件地址管理"
      >
        <template #header-right>
          <div class="delete-address"
               @click="handleDeleteAddress"
          >
            {{ deleteBtnText }}
          </div>
        </template>
      </top-bar>
    </template>
    <div v-if="list.length > 0"
         class="address-list"
    >
      <div class="item-block ym-hairline--bottom"
           v-for="(item, index) in list"
           :key="index"
           @click="handleChooseAddress(item)"
      >
        <div class="del-icon"
             :class="{'active': showDelIcon}"
             @click.stop="deleteAddress(item.id)"
        >
          <ym-icon class="icon"
                   name="round-delete-fill"
          />
        </div>
        <div class="item">
          <div class="item-header">
            <div class="header-info">
              <span class="name">{{ item.consignee }}</span>
              <span class="mobile">{{ item.mobile }}</span>
              <ym-tag v-if="item.isDefault"
                      size="small"
                      type="primary-light"
                      round
              >
                默认地址
              </ym-tag>
            </div>
            <div v-if="!showDelIcon"
                 class="edit-icon"
                 @click.stop="handleEdit(item.id)"
            >
              <ym-icon name="edit" />
            </div>
          </div>
          <div class="item-content">
            {{ item.areaName }}{{ item.detailAddress }}
          </div>
        </div>
      </div>
    </div>
    <empty-page v-else-if="loaded"
                class="empty-page"
                type="address"
                hint="暂无地址"
    >
      <div class="info">
        <span>请完善您的收件地址</span>
        <span>学习工具包将在开课前一周给您寄出</span>
      </div>
    </empty-page>
    <div class="footer ym-mw-component-fixed-max">
      <ym-button v-if="!showDelIcon"
                 class="btn"
                 size="large"
                 type="primary"
                 :disabled="maxAddressNum - list.length <= 0"
                 @click="handleAddAddress"
      >
        添加地址
      </ym-button>
      <div class="tip">
        您已添加<span>{{ list.length }}</span>个收件地址，最多可创建<span>{{ maxAddressNum }}</span>个
      </div>
    </div>
  </customize-header>
</template>

<script>
  import { Button, Tag } from '@ymba/ym-ui';
  import { getMyAddressList, deleteAddress } from '@/services/user';
  import EmptyPage from '@/components/EmptyPage';
  import { getLocationQuery, appendQuery } from '@/utils';
  import TopBar from '@/components/TopBar';
  import CustomizeHeader from '@/layout/CustomizeHeaderLayout';

  export default {
    name: 'AddressList',
    metaInfo: {},
    components: {
      'ym-button': Button,
      EmptyPage,
      YmTag: Tag,
      TopBar,
      CustomizeHeader,
    },
    data() {
      return {
        loaded: false,
        list: [],
        maxAddressNum: 0,
        showDelIcon: false,
        query: getLocationQuery(),
      };
    },
    computed: {
      deleteBtnText() {
        const { showDelIcon } = this;
        return showDelIcon ? '完成' : '删除';
      },
    },
    methods: {
      async fetchData() {
        try {
          this.loaded = false;

          const data = await getMyAddressList();
          this.list = data.list;
          this.maxAddressNum = data.maxNum;

          this.loaded = true;
        } catch (e) {
          this.loaded = true;
        }
      },
      handleAddAddress() {
        const { query } = this;
        const { redirectTo, choseAddress } = query;
        const route = {
          name: 'AddressDetailSetting',
          query: { type: 'add', redirectTo, choseAddress },
        };
        this.$router.push(route);
      },
      handleDeleteAddress() {
        const { showDelIcon } = this;
        this.showDelIcon = !showDelIcon;
      },
      deleteAddress(id) {
        this.$dialog.confirm({
          message: '你确定删除此地址吗?',
        }).then(() => {
          this.saveDeleteAddress(id);
        });
      },
      async saveDeleteAddress(id) {
        await deleteAddress(id);
        this.list.splice(this.list.findIndex(item => id === item.id), 1);
      },
      handleChooseAddress(item) {
        if (this.showDelIcon) {
          this.$toast('请先保存您的修改');
          return;
        }
        const { query } = this;
        const { redirectTo, choseAddress } = query;
        if (!choseAddress) return;
        const { id: addressId } = item;
        const path = appendQuery(redirectTo, { addressId });
        this.$router.replace(path);
      },
      handleEdit(id) {
        const { query } = this;
        const { redirectTo, choseAddress } = query;
        if (!choseAddress) {
          const route = {
            name: 'AddressDetailSetting',
            query: { id, type: 'edit' },
          };
          this.$router.push(route);
          return;
        }
        const route = {
          name: 'AddressDetailSetting',
          query: {
            redirectTo,
            choseAddress,
            id,
            type: 'edit',
          },
        };
        this.$router.push(route);
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .delete-address {
    font-size: @font-size-base;
    color: @color-text-light;
  }

  .page-address-list {
    background: @color-white;
    height: 100%;
    overflow: hidden;
  }

  .item-block {
    display: flex;
    margin-left: @size-base;
    padding: @size-base @size-base @size-small 0;
    &.active {
      justify-content: space-between;
    }
  }

  .del-icon {
    margin-right: @size-base;
    display: none;
    color: @color-highlight;
    &.active {
      display: flex;
      align-items: center;
    }
    .icon {
      font-size: 40px;
    }
  }

  .item {
    width: 100%;
  }

  .item-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: @font-size-medium;
    color: @color-text-base;
    font-weight: @font-weight-primary;
    margin-bottom: @size-small;
  }

  .header-info {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .item-content {
    color: @color-text-light;
    line-height: 1.4;
  }

  .edit-icon {
    display: block;
    color: @color-text-light;
    font-size: @font-size-extra-extra-large;
  }

  .name,
  .mobile {
    font-weight: @font-weight-primary;
    margin-right: @size-base;
  }

  .empty-list {
    color: @color-text-light;
    font-size: @font-size-base;
    margin-top: 270px;
    span {
      display: block;
      text-align: center;
      margin-bottom: @size-extra-small;
    }
  }

  .footer {
    position: fixed;
    bottom: @size-base;
    padding: @size-base;
    .tip {
      margin-top: @size-small;
      font-size: @font-size-small;
      color: @color-text-lighter;
      text-align: center;
      span {
        color: @color-primary;
        font-weight: @font-weight-primary;
      }
    }
  }

  .empty-page {
    color: @color-primary;
    .info {
      margin-top: @size-medium;
      span {
        display: block;
        font-size: @font-size-base;
        text-align: center;
      }
    }
  }
</style>
